import firebase from 'firebase/app';
import 'firebase/messaging';
import querystring from 'querystring';

const {
  REACT_APP_FBC_API_KEY,
  REACT_APP_FBC_AUTH_DOMAIN,
  REACT_APP_FBC_DB_URL,
  REACT_APP_FBC_PROJECT_ID,
  REACT_APP_FBC_BUCKET,
  REACT_APP_FBC_MESSAGING_SENDER_ID,
  REACT_APP_FBC_APP_ID,
  REACT_APP_FBC_MEASUREMENT_ID,
  REACT_APP_FBC_MESSAGING_KEY,
} = process.env;

const firebaseConfig = {
  apiKey: REACT_APP_FBC_API_KEY,
  authDomain: REACT_APP_FBC_AUTH_DOMAIN,
  databaseURL: REACT_APP_FBC_DB_URL,
  projectId: REACT_APP_FBC_PROJECT_ID,
  storageBucket: REACT_APP_FBC_BUCKET,
  messagingSenderId: REACT_APP_FBC_MESSAGING_SENDER_ID,
  appId: REACT_APP_FBC_APP_ID,
  measurementId: REACT_APP_FBC_MEASUREMENT_ID,
};

firebase.initializeApp(firebaseConfig);

let messaging = null;

if (firebase.messaging.isSupported()) {
  console.log('firebase supported');

  messaging = firebase.messaging();
}

export const onMessageListener = (callback) => {
  if (!messaging) {
    if (typeof callback === 'function') return () => {};
    return new Promise(() => {});
  }

  if (typeof callback === 'function') {
    messaging.onMessage((payload) => {
      callback(payload);
    });
    return () => {};
  }

  return new Promise((resolve) => {
    messaging.onMessage((payload) => {
      resolve(payload);
    });
  });
};

export const getToken = () => {
  if (!messaging) {
    return null;
  }
  if ('serviceWorker' in navigator) {
    return navigator.serviceWorker
      .register(`/firebase-messaging-sw.js?${querystring.stringify(firebaseConfig)}`)
      .then(function (registration) {
        const resetSubscription = () => {
          if (!registration.pushManager) return Promise.resolve();
          return registration.pushManager
            .getSubscription()
            .then((sub) => (sub ? sub.unsubscribe() : null))
            .catch(() => null);
        };
        const requestPermission = () => {
          if (typeof Notification === 'undefined') {
            return Promise.resolve('denied');
          }
          if (Notification.permission === 'granted' || Notification.permission === 'denied') {
            return Promise.resolve(Notification.permission);
          }
          try {
            const maybePromise = Notification.requestPermission();
            if (maybePromise && typeof maybePromise.then === 'function') {
              return maybePromise;
            }
            return new Promise((resolve) => {
              Notification.requestPermission((perm) => resolve(perm));
            });
          } catch (_) {
            return Promise.resolve(Notification.permission);
          }
        };

        return resetSubscription()
          .then(() => requestPermission())
          .then((per) => {
            const vapid = (REACT_APP_FBC_MESSAGING_KEY || '').trim();
            const options = { serviceWorkerRegistration: registration };
            if (vapid) options.vapidKey = vapid;

            return messaging
              .getToken(options)
              .then((currentToken) => {
                if (currentToken) {
                  localStorage.setItem('fcmtoken', currentToken);
                }

                return currentToken;
              })
              .catch((err) => {
                return null;
              });
          });
      })
      .catch((err) => {
        /*send to newrelic*/
      });
  }
};
